export default function DestinationController(
  $state,
  DestinationService,
  NotificationService,
  countryService,
  UtilService,
  HTTP_CODE,
  DESTINATION_TYPES,
) {
  const vm = this;

  vm.isLoading = false;
  vm.destinationBrowserUrl = '';
  vm.inactiveDestinationParentId = null;
  vm.inactiveDestinationParams = {
    destination_type: null,
    status: 'inactive',
  };
  vm.inactiveDestinations = [];

  vm.options = {};
  vm.options.countries = [];
  vm.options.destinationTypes = [
    DESTINATION_TYPES.REGION.name,
    DESTINATION_TYPES.CITY.name,
    DESTINATION_TYPES.DISTRICT.name,
    DESTINATION_TYPES.POI.name,
  ];

  vm.init = init;
  vm.getCountries = getCountries;
  vm.getInactiveDestinations = getInactiveDestinations;
  vm.getDestinationByBrowserUrl = getDestinationByBrowserUrl;
  vm.reindexDestinations = reindexDestinations;

  init();

  function init() {
    if (!vm.inactiveDestinations.length) {
      vm.getInactiveDestinations();
    }
    if (!vm.options.countries.length) {
      vm.getCountries();
    }
  }

  function getCountries() {
    countryService.getAllCountries().then(res => {
      if (res && res.data) {
        vm.options.countries = res.data;
      }
    });
  }

  function getInactiveDestinations() {
    if (vm.isLoading) {
      return;
    }

    let params;
    vm.isLoading = true;

    params = UtilService.generateSearchUrl(vm.inactiveDestinationParams);
    const destinationIdParam = vm.inactiveDestinationParentId ? vm.inactiveDestinationParentId : 0;
    DestinationService.getDestinationChildren(destinationIdParam, params)
      .then(res => {
        vm.inactiveDestinations = res.data;
      })
      .finally(() => {
        vm.isLoading = false;
      });
  }

  function getDestinationByBrowserUrl() {
    if (vm.isLoading || !vm.destinationBrowserUrl) {
      return;
    }
    vm.isLoading = true;

    DestinationService.getDestination(vm.destinationBrowserUrl)
      .then(res => {
        const destination = angular.isArray(res.data) ? res.data.shift() : res.data;
        $state.go('app.destination.edit', { destinationId: destination.id });
      })
      .catch(res => {
        if (res.status === HTTP_CODE.STATUS.BAD_REQUEST) {
          NotificationService.error('Invalid destination path');
        }
      })
      .finally(() => {
        vm.isLoading = false;
      });
  }

  function reindexDestinations() {
    if (vm.isLoading) {
      return;
    }
    vm.isLoading = true;

    DestinationService.reindexDestinations()
      .then(() => {
        NotificationService.success('Destinations reindex initiated');
      })
      .catch(() => {
        NotificationService.error('Destinations reindex failed to initiate');
      })
      .finally(() => {
        vm.isLoading = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/destinations/destination.controller.js